import styled from "styled-components";
import {size} from "../../helpers/breakpoints";

export const Container = styled.div`
  width: 26.5rem;
  height: 100vh;
  background-color: var(--gray-color);
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid var(--border-color);

  @media only screen and (max-width: ${size.xl}) {
    width: 100vw;
    padding-bottom: 65px;
  }
`;

export const HeaderInfo = styled.div`
  height: 67px;
  max-height: 67px;
  min-height: 67px;
  width: 100%;
  position: sticky;
  top: 0;
  background-color: var(--main-color);
  border-bottom: 1px solid var(--border-color);
  padding: 1rem;
  z-index: 9;
`;

export const UsersContainer = styled.div`
  width: 100%;
  padding: .5rem;
  flex: 1;
`
